import PropTypes from 'prop-types';
import { Typography, TableRow } from '@mui/material';

import StyledTableCell from 'components/SummaryComponent/StyledTableCell';
import PriceComponent from 'components/PriceComponent';

function SummaryInfoComponent({ title, value }) {
  return (
    <TableRow>
      <StyledTableCell component="th" scope="row">
        {title}
      </StyledTableCell>

      <StyledTableCell align="right">
        <Typography
          component="span"
          sx={{ textAlign: 'right', fontWeight: 900 }}
          variant="caption"
        >
          {value > 0 ? (
            <PriceComponent value={value} />
          ) : (
            <strong>GRÁTIS</strong>
          )}
        </Typography>
      </StyledTableCell>
    </TableRow>
  );
}

SummaryInfoComponent.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};

export default SummaryInfoComponent;
